/* eslint-disable no-param-reassign */
/* eslint-disable react-hooks/exhaustive-deps */
import React, {
  useState,
  useEffect,
  useRef,
  useImperativeHandle,
  forwardRef,
} from 'react';
import * as S from './styled';

const useCollapse = initialState => {
  const [opened, setOpened] = useState(initialState);
  const toggle = () => setOpened(!opened);
  return [opened, toggle];
};

let alreadyOpened = false;
const alreadyOpenedHeight = (opened, ref) =>
  opened ? `${ref.current.children[0].offsetHeight}px` : '0px';

const handleTransition = (
  opened,
  containerRef,
  animationCb,
  setAnimationCb,
  animationTime
) => {
  if (opened) {
    containerRef.current.style.maxHeight = `${containerRef.current.children[0].offsetHeight}px`;
    alreadyOpened = true;
    setAnimationCb(
      setTimeout(() => {
        containerRef.current.style.maxHeight = 'unset';
        containerRef.current.style.overflow = 'unset';
      }, animationTime)
    );
  } else {
    containerRef.current.style.maxHeight = alreadyOpenedHeight(
      alreadyOpened,
      containerRef
    );
    clearTimeout(animationCb);
    const handleTimeout = () => {
      if (containerRef.current == null) {
        return;
      }
      containerRef.current.style.maxHeight = '0px';
      containerRef.current.style.overflow = 'hidden';
    };
    setTimeout(handleTimeout, 20);
  }
};

const Collapse = (
  { title, children, animationTime = 300, onStateChange, ...rest },
  ref
) => {
  const [opened, toggle] = useCollapse(false);
  const [animationCb, setAnimationCb] = useState(null);
  const containerRef = useRef(null);

  useImperativeHandle(
    ref,
    () => ({
      toggle,
    }),
    [toggle]
  );

  useEffect(() => {
    if (opened) {
      if (!containerRef.current) {
        return;
      }
      containerRef.current.style.maxHeight = `${containerRef.current.children[0].offsetHeight}px`;
      alreadyOpened = true;
      setAnimationCb(
        setTimeout(() => {
          containerRef.current.style.maxHeight = 'unset';
          containerRef.current.style.overflow = 'unset';
        }, animationTime)
      );
    } else {
      containerRef.current.style.maxHeight = alreadyOpenedHeight(
        alreadyOpened,
        containerRef
      );
      clearTimeout(animationCb);
      setTimeout(() => {
        containerRef.current.style.maxHeight = '0px';
        containerRef.current.style.overflow = 'hidden';
      }, 20);
    }
    handleTransition(
      opened,
      containerRef,
      animationCb,
      setAnimationCb,
      animationTime
    );
    if (onStateChange) {
      onStateChange(opened);
    }
  }, [opened]);

  return (
    <S.CollapseContainer {...rest}>
      <S.Title
        role="link"
        opened={opened}
        onKeyPress={event => {
          if (event.which === 13 || event.keyCode === 13) {
            toggle();
          }
        }}
        tabIndex={0}
        onClick={toggle}
      >
        {title}
        <i className={opened ? 'icon-seta-cima-p' : 'icon-seta-baixo-p'} />
      </S.Title>

      <S.Container
        animationTime={animationTime}
        ref={containerRef}
        opened={opened}
        data-testid="hidden-container"
      >
        {React.Children.count(children) > 1 ? <div>{children}</div> : children}
      </S.Container>
    </S.CollapseContainer>
  );
};

export default forwardRef(Collapse);
